<template>
<div>
  <div
    v-if="confirmedBooking && canRefund && languageCode && hoursBeforeRefundUnblocked && (bookingIsPreEntry && userCanRefundBookingsPreEntry || !bookingIsPreEntry)"
    class="row"
  >
    <div
      v-if="!refundInProgress"
      class="col-12"
    >
      <button
        :disabled="refundInProgress || disabled"
        class="btn btn-primary btn-block mt-4"
        @click="showRefundConfirm"
      >
        Refund booking
      </button>
    </div>
    <modal
      :height="380"
      name="booking-refund-modal"
    >
      <div class="container">
        <div class="row">
          <a
            class="button button--ghost product__info-close"
            @click="hideRefundConfirm"
          ><span class="visuallyhidden">Close</span></a>
        </div>
        <div class="row">
          <div class="col-12 mt-4">
            <h3>Refund Details</h3>
            Total Refundable amount: {{ $n(totalPossibleRefundValue, 'currency', languageCode) }}<br>
          </div>
          <div class="col-12 mt-4">
            <label>
              Refund amount:
            </label>
            <input
              v-model="refundValue"
              :class="{ 'is-invalid': $v.refundValue.$invalid}"
              class="form-control"
            >
          </div>
          <div class="col-12 mt-4">
            <label>
              Refund Reason:
            </label>
            <input
              v-model="refundMessage"
              :class="{ 'is-invalid': $v.refundMessage.$invalid}"
              class="form-control"
            >
          </div>
        </div>
        <div class="col-12 mt-4">
          <strong>Are you sure you want to refund {{ $n(refundValue, 'currency', languageCode) }} from this booking?</strong>
        </div>
        <div class="row">
          <div class="col-12 ">
            <button
              class="btn btn-info mt-4"
              @click="hideRefundConfirm"
            >
              No, close
            </button>
            <button
              :disabled="$v.$invalid || refundInProgress"
              class="btn btn-danger mt-4 pull-right"
              @click="refund"
            >
              Yes, refund {{ $n(refundValue, 'currency', languageCode) }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
  <div class="text-danger"  v-if="refundDetailsAvailable && refundDetailsAvailable.hoursBeforeRefundUnblocked">Refund is currently not possible as the payment is still in progress, please try again in {{refundDetailsAvailable.hoursBeforeRefundUnblocked}} hours.</div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { required, email, between, minLength } from 'vuelidate/lib/validators'
import moment from 'moment'
const isDecimal = (value) => /^\d*\.?\d*$/.test(value)

export default {
    name: 'Refund',
    props: ['bookingId', 'disabled'],
    data () {
        return {
            refundInProgress: false,
            refundValue: 0.00,
            refundMessage: ''
        }
    },
    computed: {
        ...mapState({
            bookingDetail: state => state.booking.bookingDetail,
            product: state => state.booking.product,
            refundDetailsAvailable: state => state.booking.refundDetails
        }),
        ...mapGetters({
            userCanRefundBookingsPreEntry: 'auth/userCanRefundBookingsPreEntry'
        }),
        confirmedBooking () {
            return this.bookingDetail !== null
                ? this.bookingDetail.status.toLowerCase() === 'confirmed'
                : false
        },
        canRefund () {
            return this.refundDetailsAvailable !== null
                ? this.refundDetailsAvailable.refundValue !== 0
                : false
        },
        bookingIsPreEntry () {
            return this.product ? moment(this.product.entryDate) > moment() : false
        },
        totalPossibleRefundValue () {
            return this.refundDetailsAvailable.refundValue ? this.refundDetailsAvailable.refundValue : 0
        },
        languageCode () {
            return this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
        },
        hoursBeforeRefundUnblocked(){
          debugger;
          return this.refundDetailsAvailable.hoursBeforeRefundUnblocked === null
                || this.refundDetailsAvailable.hoursBeforeRefundUnblocked === 0
        }
    },
    watch: {
        confirmedBooking () {
            if (this.confirmedBooking && this.refundDetailsAvailable === null) {
                this.refundValue = 0.00
                this.refundMessage = ''
                this.populate()
            }
        }
    },
    created () {
        this.populate()
    },
    validations: {
        refundValue: {
            required,
            between (value) {
                return between(0.01, this.refundDetailsAvailable.refundValue)(value)
            },
            isDecimal
        },
        refundMessage: {
            required,
            minLength: minLength(1)
        }
    },
    methods: {
        async populate () {
            if (this.confirmedBooking) { await this.$store.dispatch('getRefundDetails', this.bookingId) }
        },
        showRefundConfirm () {
            this.$modal.show('booking-refund-modal', { bookingId: this.bookingId })
        },
        hideRefundConfirm () {
            this.$modal.hide('booking-refund-modal')
        },
        async refund () {
            if (this.$v.$invalid) {
                return
            }
            this.refundInProgress = true
            var result = await this.$store.dispatch('refundBooking',
                {
                    bookingId: this.bookingId,
                    amount: this.refundValue,
                    reason: this.refundMessage
                })

            if (result.status === 204) {
                this.refundValue = 0.00
                this.refundMessage = ''
                this.reloadBookingData()
                this.$toasted.success('Refund Issued')
            } else {
                this.$toasted.error(`Not Refunded. ${result.data}`)
            }
            this.$modal.hide('booking-refund-modal')
            this.refundInProgress = false
        },
        reloadBookingData () {
            this.$store.dispatch('getBookingType', this.bookingId)
            this.$store.dispatch('getBookingDetail', this.$route.params.bookingId)
            this.$store.dispatch('getBookingHistory', this.$route.params.bookingId)
            this.populate()
            this.$store.dispatch('getCustomer', this.$route.params.bookingId)
            this.$store.dispatch('getAudit', this.$route.params.bookingId)
            this.$store.dispatch('getFlightDetails', this.$route.params.bookingId)
            this.$store.dispatch('getNotes', this.$route.params.bookingId)
            this.$store.dispatch('getPaymentDetail', this.$route.params.bookingId)
            this.$store.dispatch('getPaymentHistory', this.$route.params.bookingId)
            this.$store.dispatch('getProduct', this.$route.params.bookingId)
            this.$store.dispatch('getProductExtras', this.$route.params.bookingId)
            this.$store.dispatch('getAirports')
            this.$store.dispatch('getVehicle', this.$route.params.bookingId)
        }
    }
}
</script>
